const getDefaultStateTargetPromoter = () => {
  return {
    comitatoTargetPromoter: null,
    cognomeTargetPromoter: null,
    rowsToSkipTargetPromoter: 0,
    fetchRowsTargetPromoter: 25,
    currentPageTargetPromoter: 1,
    sortColumnTargetPromoter: "promoter",
    sortOrderTargetPromoter: "asc",
  };
};
const state = getDefaultStateTargetPromoter();

const getters = {
  comitatoTargetPromoter: (state) => state.comitatoTargetPromoter,
  cognomeTargetPromoter: (state) => state.cognomeTargetPromoter,
  rowsToSkipTargetPromoter: (state) => state.rowsToSkipTargetPromoter,
  fetchRowsTargetPromoter: (state) => state.fetchRowsTargetPromoter,
  currentPageTargetPromoter: (state) => state.currentPageTargetPromoter,
  sortColumnTargetPromoter: (state) => state.sortColumnTargetPromoter,
  sortOrderTargetPromoter: (state) => state.sortOrderTargetPromoter,
};

// const actions = {};
const mutations = {
  setComitatoTargetPromoter: (state, value) => {
    state.comitatoTargetPromoter = value;
  },
  setCognomeTargetPromoter: (state, value) => {
    state.cognomeTargetPromoter = value;
  },
  setFetchRowsTargetPromoter: (state, value) => {
    state.currentPageTargetPromoter = 1;
    state.rowsToSkipTargetPromoter = 0;
    state.fetchRowsTargetPromoter = value;
  },
  setCurrentPageTargetPromoter: (state, value) => {
    state.currentPageTargetPromoter = value;
    state.rowsToSkipTargetPromoter = parseInt(
      (state.currentPageTargetPromoter - 1) * state.fetchRowsTargetPromoter
    );
  },
  setSortColumnTargetPromoter: (state, value) => {
    state.sortColumnTargetPromoter = value;
  },
  setSortOrderTargetPromoter: (state, value) => {
    state.sortOrderTargetPromoter = value;
  },
  setCategoriaTargetPromoter: (state, value) => {
    state.id_categoriaTargetPromoter = value;
  },
  resetFiltersTargetPromoter: (state) => {
    Object.assign(state, getDefaultStateTargetPromoter());
  },
  resetRowsToSkipTargetPromoter: (state) => {
    state.currentPageTargetPromoter = 1;
    state.rowsToSkipTargetPromoter = 0;
  },
};

export default {
  state,
  getters,
  mutations,
};
